function convertCmToFeet(num) {
  let eq =
    "Converting " +
    num +
    " centimeter to feet: \n" +
    num +
    " * 0.032808 = ";
  let rep = num * 0.032808;
  return eq + rep.toFixed(4);;
}

function convertCmToInches(num) {
  let eq =
    "Converting " + num + " centimeter to inches: \n" + num + " * 0.39370 = ";
  let rep = num * 0.39370;
  return eq + rep.toFixed(3);
}

function convertCmToYards(num) {
  let eq =
    "Converting " +
    num +
    " centimeter to yards: \n" +
    num +
    " * 0.010936 = ";
  let rep = num * 0.010936;
  return eq + rep.toFixed(4);
}

function convertCmToMiles(num) {
  let eq =
    "Converting " +
    num +
    " centimeter to miles: \n" +
    num +
    " * 0.0000062137 = ";
  let rep = num * 0.0000062137;
  return eq + rep.toFixed(6);
}

function convertCmToMeters(num) {
  let eq =
    "Converting " +
    num +
    " centimeter to meters: \n" +
    num +" / 100 = ";
  let rep = num / 100;
  return eq + rep.toFixed(3);
}

function convertCmToKilometers(num) {
  let eq =
    "Converting " +
    num +
    " centimeter to kilometers: \n" +
    num +
    " / 100000 = ";
  let rep = num / 100000;
  return eq + rep.toFixed(6);
}

export {
  convertCmToFeet,
  convertCmToInches,
  convertCmToYards,
  convertCmToMiles,
  convertCmToMeters,
  convertCmToKilometers
};
